var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Axo extends Component {
    constructor() {
        super('Axo', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            const shapes = $('.module-axo #shapes > *');
            $('.module-axo #btn-group > *').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                const place_id = button.attr('id').replace('btn-', '');
                $('#axo-informations-loader').removeClass('d-none').addClass('d-flex');
                $('#axo-informations-container').empty();
                shapes.removeClass('active');
                $('#' + place_id).addClass('active');
                const place_details = yield $.httpRequest({
                    url: '/wp-admin/admin-ajax.php',
                    dataType: 'html',
                    type: 'POST',
                    body: {
                        action: 'load_place_details',
                        place_id: place_id
                    }
                });
                $('#axo-informations-loader').addClass('d-none').removeClass('d-flex');
                $('#axo-informations-container').append(place_details);
            }));
            this.success();
        });
    }
}
